import { parse, format } from 'date-fns'

export default function convertDateFormat(input: string, inputFormat = 'yyyy-MM', outputFormat = 'MMM'): string {
  return format(parse(input, inputFormat, new Date()), outputFormat)
}
